import { PlacesView } from "../VIEW/PlacesView";

function PlacesPage() {
  return <PlacesView />;
}

export default PlacesPage;
